import { Observable, Subject } from "rxjs";
import { Message } from "./message";

/**
 * Representa uma conversação, que contém obrigatoriamente um identificador.
 * 
 */
export class Conversation {

    // Identificador obrigatório.
    id: string;

    // Data que a conversação foi iniciada.
    date: Date;

    isFinalized: boolean = false;

    // Todas as mensagens que foram trocadas nesta conversação.
    // Está ordenada pela ordem de inserção.
    private _messages: Message[] = [];

    private newMessageSubject: Subject<Message> = new Subject<Message>();

    get messages(): ReadonlyArray<Message> {
        return this._messages;
    }

    onNewMessage(): Observable<Message> {
        if  (this.isFinalized) {
            throw new Error('Esta conversação já se encontra finalizada e não pode mais receber mensagens.');
        }

        return this.newMessageSubject.asObservable();
    }

    constructor(id: string, date: Date = new Date()) {
        if (!id) {
            throw "ID da conversação é obrigatório.";
        }

        this.id = id;
        this.date = date;
    }

    /**
     * Adicionar uma nova mensagem à conversação.
     * A mensagem não pode ser repetida (ter o mesmo ID que outra mensagem).
     * 
     * @param message Mensagem que deve ser adicionada.
     */
    addMessage(message: Message) {
        if  (this.isFinalized) {
            throw new Error('Esta conversação já se encontra finalizada e não pode mais receber mensagens.');
        }

        let index = this._messages.findIndex((m) => { m.id === message.id });

        if (index <= -1) {
            this._messages.push(message);
            message.conversation = this;
            this.newMessageSubject.next(message);
        }
    }

    finalize(): void {
        this.isFinalized = true;
    }
}